import { ref } from 'vue'

export const showMobileLeftMenu = ref(false)
export const showMobileAccountSheet = ref(false)
